// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".informe-respuestas[data-v-2ee3b238]{min-width:0}.informe-respuestas h3[data-v-2ee3b238]{font-size:16px}.informe-respuestas td[data-v-2ee3b238],.informe-respuestas th[data-v-2ee3b238]{min-width:85px;font-size:12px;vertical-align:middle}.informe-respuestas .nav-link[data-v-2ee3b238]{font-size:12px;margin:0 4px 4px 0}.informe-respuestas li[data-v-2ee3b238]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
